<template>
  <div class="submit-success">
    <h2 class="section-heading mb-5">Application Submitted</h2>
    <p>Thank you for submitting your application. You can no longer edit your application and there is nothing else for you to do at the current time.</p>
    <p class="mb-5">You will be notified by email of the next step.</p>
    <p>You will now be logged out</p>
  </div>    
</template>

<script>
import { mapActions } from 'vuex'
export default {
  mounted () {
    localStorage.clear()
    setTimeout(() => {
      window.scrollTo(0,0);
    }, 50)
    setTimeout(() => {
      this.logoutAction()
    }, 15000)
  },
  methods: {
    ...mapActions({
      logoutAction: 'authStore/logoutAction'
    }),
    async handleLogout () {
      await this.logoutAction()
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.submit-success {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 10px;
}
</style>